import { createSlice } from "@reduxjs/toolkit";

export const downloadSlice = createSlice({
  name: "downloadSlice",
  initialState: {
    Resolution: "",
    Format: 0,
    Quality: 90,
    Image: "",
    BatchImages: [],
    Extension: "",
    Create: false,
    mainImageWidth: 0,
    mainImageHeight: 0,
    readyTodownload: false,
    templateReady_image: false,
    templateReady: false,
    Found: false,
  },
  reducers: {
    setResolution: (state, action) => {
      state.Resolution = action.payload;
    },
    setFormat: (state, action) => {
      state.Format = action.payload;
    },
    setQuality: (state, action) => {
      state.Quality = action.payload;
    },
    setSettings: (state, action) => {
      state.Quality = action.payload.Quality;
      state.Format = action.payload.Format;
      state.Resolution = action.payload.Resolution;
      state.Found = action.payload.Found;
    },
    setImage: (state, action) => {
      state.Image = action.payload.img;
      state.mainImageWidth = action.payload.width;
      state.mainImageHeight = action.payload.height;
      state.readyTodownload = action.payload.readyTodownload;
    },
    setCreate: (state, action) => {
      state.Create = action.payload;
    },
    setTemplateReady: (state, action) => {
      state.templateReady = action.payload;
      state.templateReady_image = action.payload;
    },
    setTemplateClearPhase1: (state, action) => {
      state.templateReady_image = action.payload;
    },
    setTemplateClearPhase2: (state, action) => {
      state.templateReady = action.payload;
      state.Image = action.payload;
      state.Create = action.payload;
    },
    setExtension: (state, action) => {
      state.Extension = action.payload;
    },
    setBatchImages: (state, action) => {
      if (!action.payload) state.BatchImages = [];
      else state.BatchImages = [...state.BatchImages, action.payload];
    },
    setClean: (state) => {
      // state.Resolution = "";
      // state.Quality = 50;
      state.Image = "";
      state.Create = false;
      // state.mainImageWidth = 0;
      // state.mainImageHeight = 0;
      state.readyTodownload = false;
    },
  },
  setFound: (state, action) => {
    state.Found = action.payload;
  },
});

// Action creators are generated for each case reducer function
export const {
  setResolution,
  setFormat,
  setQuality,
  setSettings,
  setImage,
  setCreate,
  setExtension,
  setClean,
  setTemplateReady,
  setTemplateClearPhase1,
  setTemplateClearPhase2,
  setFound,
  setBatchImages,
} = downloadSlice.actions;

export default downloadSlice.reducer;
